<div class="text1">{{ list[data].text1 }}</div>
<div class="text2">{{ list[data].text2 }}</div>
<div class="text3">{{ list[data].text3 }}</div>
<div class="text4">{{ list[data].text4 }}</div>
<img src="https://qiniu.goingbus.com/business_service_qrcode.jpg" />
<div class="text2">{{ list[data].text5 }}</div>
<button mat-dialog-close>确认</button>
